export default "__VITE_ASSET__$f9L7VQq__"